export enum FilterType {
  All,
  Classic,
  Flash,
  Featured,
  AgeRestricted,
}
